var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modalPopover",
        title: "Ενημέρωση εφαρμογής",
        "ok-only": "",
        "ok-title": "Ενημέρωση Εφαρμογής",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "hide-header-close": ""
      },
      on: { ok: _vm.handleUpdate },
      model: {
        value: _vm.hasToUpdate,
        callback: function($$v) {
          _vm.hasToUpdate = $$v
        },
        expression: "hasToUpdate"
      }
    },
    [
      _c("p", [
        _vm._v(
          "\n    Δυστυχώς θα πρέπει να ενημερώσεις την εφαρμογή για να μπορέσεις συνεχίσεις.\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d43cf9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59d43cf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","b-avatar":"src","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"src","b-card-img-lazy":["src","blank-src"],"b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalAlert.vue
// module id = null
// module chunks = 